module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [(_vm.reviewsObject) ? _c('div', {
    staticClass: "webinar-reviews"
  }, [_c('h5', {
    staticClass: "has-text-centered unpublished"
  }, [_c('span', [_vm._v("Неопубликованные отзывы " + _vm._s(_vm.unpublished.length))])]), _vm._v(" "), _vm._l((_vm.unpublished), function(review) {
    return _c('WebinarItem', {
      key: review.id,
      attrs: {
        "review": review
      }
    })
  }), _vm._v(" "), _c('h5', {
    staticClass: "has-text-centered published"
  }, [_c('span', [_vm._v("Опубликованные отзывы " + _vm._s(_vm.published.length))])]), _vm._v(" "), _vm._l((_vm.published), function(review) {
    return _c('WebinarItem', {
      key: review.id,
      attrs: {
        "review": review
      }
    })
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01f44656"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/WebinarReviews.vue
// module id = 882
// module chunks = 0